import script from "./ButtonScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./ButtonScroll.vue?vue&type=script&setup=true&lang=js"

import "./ButtonScroll.vue?vue&type=style&index=0&id=7c170a71&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eni-dist_longform-just-transition-persone/eni-dist_longform-just-transition-persone/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7c170a71"]])

export default __exports__